<template>
  <div
    class="d-flex header-height position-relative container my-3 mt-md-0 mb-md-2"
    :class="{ unicorn: isAnUnicorn }"
  >
    <div class="d-flex row justify-content-between my-auto w-100">
      <div class="col-8 offset-md-2 text-md-center">
        <div v-if="isAnUnicorn ">
          <span class="h1">
            👻 Mode usurpation 👻
          </span>
        </div>
        <router-link
          v-else
          v-slot="{ navigate }"
          to="/login"
          custom
        >
          <img
            :src="aws + '/logo-blue-700.svg'"
            width="116px"
            alt="Logo Assurup"
            class="img-fluid m-md-auto"
            @click="navigate"
          >
        </router-link>
      </div>

      <div
        v-if="isLogged"
        v-click-outside="hide"
        class="col-2 d-flex position-relative"
      >
        <transition
          name="slide"
          tag="div"
        >
          <div
            v-if="open"
            class="position-absolute"
            style="z-index: 100;top: 100%; right: 0;"
          >
            <ul class="list-group rounded-4 pe-1 text-nowrap">
              <router-link
                v-if="isNotSignatureView"
                v-slot="{ navigate }"
                to="/client/account"
                custom
              >
                <button
                  type="button"
                  class="py-2 px-6 list-group-item list-group-item-action"
                  @click="(event) => goToAccount(navigate, event)"
                >
                  Mon compte
                </button>
              </router-link>
              <router-link
                v-if="hasAddtionalsCompanies"
                v-slot="{ navigate }"
                to="/client/accounts"
                custom
              >
                <button
                  type="button"
                  class="py-2 px-6 list-group-item list-group-item-action"
                  @click="(event) => goToAccount(navigate, event)"
                >
                  Changer d'entreprise
                </button>
              </router-link>
              <button
                type="button"
                class="py-2 px-6 list-group-item list-group-item-action"
                @click="disconnect"
              >
                Me déconnecter
              </button>
            </ul>
          </div>
        </transition>
        <div
          class="ms-auto"
          @click="toggleMenu"
        >
          <v-icon
            icon="user-circle"
            height="24"
            width="24"
            class="cursor-pointer ms-auto"
            :class="{'bg-white': isAnUnicorn}"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import ClickOutside from 'vue-click-outside';
import { mapGetters } from 'vuex';
import { ui } from '@/mixins';

export default {
  name: 'MainHeader',
  directives: {
    ClickOutside,
  },
  mixins: [ui],
  data() {
    return {
      open: false,
    };
  },
  computed: {
    ...mapGetters({
      isAnUnicorn: 'isAnUnicorn',
      additionalCompanies: 'client/additionalCompanies',
    }),
    aws: () => `${import.meta.env.VITE_AWS_STATIC}/common/svg`,
    isNotSignatureView() {
      return !this.$route.path.includes('signature');
    },
    isLogged() {
      return this.$store.getters['client/isLogged'];
    },
    hasAddtionalsCompanies() {
      if (this.additionalCompanies && this.additionalCompanies.length > 0) {
        return true;
      }
      return false;
    },
  },
  methods: {
    async disconnect() {
      try {
        await this.$store.dispatch('disconnect');
        this.$router.push('/login');
      } catch (error) {
        console.error('Error during disconnection:', error);
      }
    },
    hide() {
      this.open = false;
    },
    toggleMenu() {
      this.open = !this.open;
    },
    goToAccount(navigate, event) {
      this.hide();
      navigate(event);
    },
  },
};
</script>
<style scoped>
.unicorn .h1 {
    color:white!important;
}
.unicorn {
  background-color: var(--bs-blue-700);
}
@media screen and (min-width: 576px) {
  .header-height {
    height:132px;
  }
}
</style>
